/**
 * VidyoClientMessages
 * Helper class for creating Vidyo InEvent/OutEvent messages
 */
namespace SmartVideo {
export class VidyoClientMessages {
    constructor() {
    }

    message(type) {
        const obj = <any>{};
        obj.type = type;
        return obj;
    }

    inEvent(type) {
        const inEvent = this.message(type);
        return inEvent;
    }

    event(type) {
        const event = this.message(type);
        return event;
    }

    request(type) {
        const request = this.message(type);
        return request;
    }

    inEventleave() {
        const inEventleave = this.inEvent('InEventLeave');
        return inEventleave;
    }

    eventPreview(params) {
        const eventPreview = this.event('EventPreview');
        eventPreview.previewMode = params && params.previewMode || 'None';
        return eventPreview;
    }

    inEventMute(type, params) {
        const inEventMute = this.inEvent(type);
        inEventMute.willMute = params && params.willMute || false;
        return inEventMute;
    }

    inEventMuteAudioIn(params) {
        const inEventMuteAudioIn = this.inEventMute('InEventMuteAudioIn', params);
        return inEventMuteAudioIn;
    }

    inEventMuteAudioOut(params) {
        const inEventMuteAudioOut = this.inEventMute('InEventMuteAudioOut', params);
        return inEventMuteAudioOut;
    }

    inEventMuteVideo(params) {
        const inEventMuteVideo = this.inEventMute('InEventMuteVideo', params);
        return inEventMuteVideo;
    }

    inEventShare(params) {
        const inEventShare = this.inEvent('InEventShare');
        inEventShare.window = params && params.window || '0x0000000000000000';
        return inEventShare;
    }

    inEventUnshare() {
        const inEventUnshare = this.inEvent('InEventUnshare');
        return inEventUnshare;
    }

    inEventLayout(params) {
        const inEventLayout = this.inEvent('InEventLayout');
        inEventLayout.numPreferred = params && params.numPreferred || 0;
        return inEventLayout;
    }

    inEventPrivateChat(params) {
        const inEventPrivateChat = this.inEvent('InEventPrivateChat');
        inEventPrivateChat.uri = params && params.uri || '';
        inEventPrivateChat.message = params && params.message || '';
        return inEventPrivateChat;
    }

    inEventGroupChat(params) {
        const inEventGroupChat = this.inEvent('InEventGroupChat');
        inEventGroupChat.message = params && params.message || '';
        return inEventGroupChat;
    }

    inEventSetFreezeImage(params) {
        const inEventSetFreezeImage = this.inEvent('InEventSetFreezeImage');
        inEventSetFreezeImage.freeze = params && (params.freeze !== undefined) || true;
        return inEventSetFreezeImage;
    }

    outEventLogicStartedType() {
        return 'OutEventLogicStarted';
    }

    outEventConferenceActiveType() {
        return 'OutEventConferenceActive';
    }

    outEventConferenceEndedType() {
        return 'OutEventConferenceEnded';
    }

    outEventParticipantsChangedType() {
        return 'OutEventParticipantsChanged';
    }

    outEventMutedAudioInType() {
        return 'OutEventMutedAudioIn';
    }

    outEventMutedAudioOutType() {
        return 'OutEventMutedAudioOut';
    }

    outEventMutedVideoType() {
        return 'OutEventMutedVideo';
    }

    outEventMutedServerAudioInType() {
        return 'OutEventMutedServerAudioIn';
    }

    outEventMutedServerVideoType() {
       return 'OutEventMutedServerVideo';
    }

    outEventAddShareType() {
       return 'OutEventAddShare';
    }

    outEventRemoveShareType() {
       return 'OutEventRemoveShare';
    }

    outEventPrivateChatType() {
        return 'OutEventPrivateChat';
    }

    outEventGroupChatType() {
        return 'OutEventGroupChat';
    }

    outEventConferenceInfoUpdateType() {
       return 'OutEventConferenceInfoUpdate';
    }

    outEventCallStateType() {
       return 'OutEventCallState';
    }

    requestConfiguration(type, params) {
        const requestConfiguration = this.request(type);

        requestConfiguration.microphones = params && params.microphones || [''];
        requestConfiguration.numberMicrophones = params && params.numberMicrophones || 0;
        requestConfiguration.currentMicrophone = params && params.currentMicrophone || 0;
        requestConfiguration.speakers = params && params.speakers || [''];
        requestConfiguration.numberSpeakers = params && params.numberSpeakers || 0;
        requestConfiguration.currentSpeaker = params && params.currentSpeaker || 0;
        requestConfiguration.cameras = params && params.cameras || [''];
        requestConfiguration.numberCameras = params && params.numberCameras || 0;
        requestConfiguration.currentCamera = params && params.currentCamera || 0;
        requestConfiguration.enableFeccEndpoint = params && params.enableFeccEndpoint || 0;
        requestConfiguration.enableFeccController = params && params.enableFeccController || 0;
        requestConfiguration.vidyoProxies = params && params.vidyoProxies || [''];
        requestConfiguration.numberVidyoProxies = params && params.numberVidyoProxies || 0;
        requestConfiguration.currentVidyoProxy = params && params.currentVidyoProxy || 0;
        requestConfiguration.userID = params && params.userID || '';
        requestConfiguration.password = params && params.password || '';
        requestConfiguration.serverAddress = params && params.serverAddress || '';
        requestConfiguration.serverPort = params && params.serverPort || '';
        requestConfiguration.vidyoProxyAddress = params && params.vidyoProxyAddress || '';
        requestConfiguration.vidyoProxyPort = params && params.vidyoProxyPort || '';
        requestConfiguration.webProxyAddress = params && params.webProxyAddress || '';
        requestConfiguration.webProxyPort = params && params.webProxyPort || '';
        requestConfiguration.webProxyUsername = params && params.webProxyUsername || '';
        requestConfiguration.webProxyPassword = params && params.webProxyPassword || '';
        requestConfiguration.webProxyIeAddress = params && params.webProxyIeAddress || '';
        requestConfiguration.webProxyIePort = params && params.webProxyIePort || '';
        requestConfiguration.portalAddress = params && params.portalAddress || '';
        requestConfiguration.ringtoneDeviceName = params && params.ringtoneDeviceName || '';
        requestConfiguration.verifyCertPortalAcct = params && params.verifyCertPortalAcct || '';
        requestConfiguration.webProxyScriptUrl = params && params.webProxyScriptUrl || '';
        requestConfiguration.webProxyIeScriptUrl = params && params.webProxyIeScriptUrl || '';
        requestConfiguration.mediaLowPort = params && params.mediaLowPort || 0;
        requestConfiguration.mediaHighPort = params && params.mediaHighPort || 0;
        requestConfiguration.proxySettings = params && params.proxySettings || 0;
        requestConfiguration.videoPreferences = params && params.videoPreferences || 'BestQuality';
        requestConfiguration.enableLogging = params && params.enableLogging || 0;
        requestConfiguration.enableAutoAnswer = params && params.enableAutoAnswer || 0;
        requestConfiguration.enableForceProxy = params && params.enableForceProxy || 0;
        requestConfiguration.enableLogWindow = params && params.enableLogWindow || 0;
        requestConfiguration.enableEntryTone = params && params.enableEntryTone || 0;
        requestConfiguration.enableEchoDetection = params && params.enableEchoDetection || 0;
        requestConfiguration.enableEchoCancellation = params && params.enableEchoCancellation || 0;
        requestConfiguration.enableFullScreenVideo = params && params.enableFullScreenVideo || 0;
        requestConfiguration.showToolbarInFullScreenVideo = params && params.showToolbarInFullScreenVideo || 0;
        requestConfiguration.enableAudioAGC = params && params.enableAudioAGC || 0;
        requestConfiguration.enableAutoStart = params && params.enableAutoStart || 0;
        requestConfiguration.enableShowConfParticipantName = params && params.enableShowConfParticipantName || 0;
        requestConfiguration.enableMuteMicrophoneOnJoin = params && params.enableMuteMicrophoneOnJoin || 0;
        requestConfiguration.enableHideCameraOnJoin = params && params.enableHideCameraOnJoin || 0;
        requestConfiguration.enableMuteSpeakerOnJoin = params && params.enableMuteSpeakerOnJoin || 0;
        requestConfiguration.enableEulaAgreed = params && params.enableEulaAgreed || 0;
        requestConfiguration.enableRendering = params && params.enableRendering || 0;
        requestConfiguration.enableBackgrounding = params && params.enableBackgrounding || 0;
        requestConfiguration.enableFullDisplaySharing = params && params.enableFullDisplaySharing || 0;
        requestConfiguration.selfViewLoopbackPolicy = params && params.selfViewLoopbackPolicy || 2;

        return requestConfiguration;
    }

    requestGetConfiguration(params) {
        const requestGetConfiguration = this.requestConfiguration('RequestGetConfiguration', params);
        return requestGetConfiguration;
    }

    requestSetConfiguration(params) {
        const requestSetConfiguration = this.requestConfiguration('RequestSetConfiguration', params);
        return requestSetConfiguration;
    }

    requestVolumeAudio(type, params) {
        const requestVolumeAudio = this.request(type);
        requestVolumeAudio.volume = params && params.volume || 0;
        return requestVolumeAudio;
    }

    requestGetVolumeAudioIn(params) {
        const requestGetVolumeAudioIn = this.requestVolumeAudio('RequestGetVolumeAudioIn', params);
        return requestGetVolumeAudioIn;
    }

    requestSetVolumeAudioIn(params) {
        const requestSetVolumeAudioIn = this.requestVolumeAudio('RequestSetVolumeAudioIn', params);
        return requestSetVolumeAudioIn;
    }

    requestGetVolumeAudioOut(params) {
        const requestGetVolumeAudioOut = this.requestVolumeAudio('RequestGetVolumeAudioOut', params);
        return requestGetVolumeAudioOut;
    }

    requestSetVolumeAudioOut(params) {
        const requestSetVolumeAudioOut = this.requestVolumeAudio('RequestSetVolumeAudioOut', params);
        return requestSetVolumeAudioOut;
    }

    requestWindowShares(type?, params?) {
        const requestWindowShares = this.request(type);
        requestWindowShares.requestType = params && params.requestType || '';
        requestWindowShares.remoteAppUri = params && params.remoteAppUri || [''];
        requestWindowShares.remoteAppName = params && params.remoteAppName || [''];
        requestWindowShares.numApp = params && params.numApp || 0;
        requestWindowShares.currApp = params && params.currApp || 0;
        requestWindowShares.eventUri = params && params.eventUri || '';
        requestWindowShares.newApp = params && params.newApp || 0;
        return requestWindowShares;
    }

    requestGetWindowShares(params) {
        const requestGetWindowShares = this.requestWindowShares('RequestGetWindowShares', params);
        return requestGetWindowShares;
    }

    requestSetWindowShares(params) {
        const requestSetWindowShares = this.requestWindowShares('RequestSetWindowShares', params);
        return requestSetWindowShares;
    }

    requestGetCurrentSessionDisplayInfo(params) {
        const requestGetCurrentSessionDisplayInfo = this.request('RequestGetCurrentSessionDisplayInfo');
        requestGetCurrentSessionDisplayInfo.sessionDisplayContext = params && params.sessionDisplayContext || 'Conf';
        requestGetCurrentSessionDisplayInfo.sessionDisplayText = params && params.sessionDisplayText || '';
        return requestGetCurrentSessionDisplayInfo;
    }

    requestGetParticipants(params) {
        const requestGetParticipants = this.request('RequestGetParticipants');
        requestGetParticipants.name = params && params.name || [];
        return requestGetParticipants;
    }

    requestGetNumParticipants(params) {
        const requestGetNumParticipants = this.request('RequestGetNumParticipants');
        requestGetNumParticipants.numParticipants = params && params.numParticipants || 0;
        return requestGetNumParticipants;
    }

    requestGetParticipantStatisticsAt(params) {
        const requestGetParticipantStatisticsAt = this.request('RequestGetParticipantStatisticsAt');
        requestGetParticipantStatisticsAt.index = params && params.index || 0;
        requestGetParticipantStatisticsAt.result = params && params.result || false;
        requestGetParticipantStatisticsAt.uri = params && params.uri || '';
        requestGetParticipantStatisticsAt.name = params && params.name || '';
        requestGetParticipantStatisticsAt.videoResolution = params && params.videoResolution || {
            'xPos': 0,
                'yPos': 0,
                'width': 0,
                'height': 0
        };
        requestGetParticipantStatisticsAt.videoKBitsPerSecRecv = params && params.videoKBitsPerSecRecv || 0;
        requestGetParticipantStatisticsAt.audioKBitsPerSecRecv = params && params.audioKBitsPerSecRecv || 0;
        requestGetParticipantStatisticsAt.firs = params && params.firs || 0;
        requestGetParticipantStatisticsAt.nacks = params && params.nacks || 0;
        requestGetParticipantStatisticsAt.videoFrameRate = params && params.videoFrameRate || 0;
        requestGetParticipantStatisticsAt.videoDecodedFrameRate = params && params.videoDecodedFrameRate || 0;
        requestGetParticipantStatisticsAt.videoDisplayedFrameRate = params && params.videoDisplayedFrameRate || 0;
        return requestGetParticipantStatisticsAt;
    }

    requestGetWindowsAndDesktops(params) {
        const requestGetWindowsAndDesktops = this.request('RequestGetWindowsAndDesktops');
        requestGetWindowsAndDesktops.numApplicationWindows = params && params.numApplicationWindows || 0;
        requestGetWindowsAndDesktops.appWindowName = params && params.appWindowName || [''];
        requestGetWindowsAndDesktops.appWindowAppName = params && params.appWindowAppName || [''];
        requestGetWindowsAndDesktops.appWindowId = params && params.appWindowId || ['0x0000000000000000'];
        requestGetWindowsAndDesktops.numSystemDesktops = params && params.numSystemDesktops || 0;
        requestGetWindowsAndDesktops.sysDesktopName = params && params.sysDesktopName || [''];
        requestGetWindowsAndDesktops.sysDesktopId = params && params.sysDesktopId || ['0x0000000000000000'];
        return requestGetWindowsAndDesktops;
    }

    requestGetPreviewMode(params) {
        const requestGetPreviewMode = this.request('RequestGetPreviewMode');
        requestGetPreviewMode.previewMode = params && params.previewMode || '';
        return requestGetPreviewMode;
    }

    requestGetMutedAudioIn(params) {
        const requestGetMutedAudioIn = this.request('RequestGetMutedAudioIn');
        requestGetMutedAudioIn.isMuted = params && params.isMuted || false;
        return requestGetMutedAudioIn;
    }

    requestGetMutedAudioOut(params) {
        const requestGetMutedAudioOut = this.request('RequestGetMutedAudioOut');
        requestGetMutedAudioOut.isMuted = params && params.isMuted || false;
        return requestGetMutedAudioOut;
    }

    requestGetMutedVideo(params) {
        const requestGetMutedVideo = this.request('RequestGetMutedVideo');
        requestGetMutedVideo.isMuted = params && params.isMuted || false;
        return requestGetMutedVideo;
    }

    requestGetMutedServerAudioIn(params) {
        const requestGetMutedServerAudioIn = this.request('RequestGetMutedServerAudioIn');
        requestGetMutedServerAudioIn.isMuted = params && params.isMuted || false;
        return requestGetMutedServerAudioIn;
    }

    requestGetMutedServerVideo(params) {
        const requestGetMutedServerVideo = this.request('RequestGetMutedServerVideo');
        requestGetMutedServerVideo.isMuted = params && params.isMuted || false;
        return requestGetMutedServerVideo;
    }

    requestGetCurrentUser(params) {
        const requestGetCurrentUser = this.request('RequestGetCurrentUser');
        requestGetCurrentUser.currentUserID = params && params.currentUserID || '';
        requestGetCurrentUser.currentUserDisplay = params && params.currentUserDisplay || '';
        return requestGetCurrentUser;
    }

    requestGetConferenceInfo(params) {
        const requestGetConferenceInfo = this.request('RequestGetConferenceInfo');
        requestGetConferenceInfo.recording = params && params.recording || false;
        requestGetConferenceInfo.webcasting = params && params.webcasting || false;
        return requestGetConferenceInfo;
    }

    requestGetCallState(params) {
        const requestGetCallState = this.request('RequestGetCallState');
        requestGetCallState.callState = params && params.callState || '';
        return requestGetCallState;
    }

    requestGetEncodeResolution(params) {
        const requestGetEncodeResolution = this.request('RequestGetEncodeResolution');
        requestGetEncodeResolution.rect = params && params.rect || {xPos: 0, yPos: 0, width: 0, height: 0};
        return requestGetEncodeResolution;
    }

    requestGetVideoFrameRateInfo(params) {
        const requestGetVideoFrameRateInfo = this.request('RequestGetVideoFrameRateInfo');
        requestGetVideoFrameRateInfo.captureFrameRate	= params && params.captureFrameRate || 0;
        requestGetVideoFrameRateInfo.encodeFrameRate	= params && params.encodeFrameRate || 0;
        requestGetVideoFrameRateInfo.sendFrameRate	= params && params.sendFrameRate || 0;
        return requestGetVideoFrameRateInfo;
    }

    requestGetMediaInfo(params) {
        const requestGetMediaInfo = this.request('RequestGetMediaInfo');
        requestGetMediaInfo.numIFrames = params && params.numIFrames || 0;
        requestGetMediaInfo.numFirs    = params && params.numFirs || 0;
        requestGetMediaInfo.numNacks   = params && params.numNacks || 0;
        requestGetMediaInfo.mediaRTT   = params && params.mediaRTT || 0;
        return requestGetMediaInfo;
    }
}
}
